var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d2-quill" }, [
    _c("div", { ref: "editor", style: { height: _vm.vueheight + "px" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }